<template>
  <div id="logs">
    <div id="logs-title">
      <div class="title-bar">
        <h1>Country Errors</h1>
        <a-button @click="loadLogs()" :disabled="loading">
          <a-icon type="sync" />
        </a-button>
      </div>
    </div>
    <a-table
      v-if="!loading"
      :rowKey="record => record.LeadGenId"
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :loading="loading"
    >
      <template slot="last-request" slot-scope="requestTime, record">
        <router-link
          :to="{path:`/view-country-error/${record.FormId}/${record.LeadGenId}`, query: {processor: determineProcessor(record.LeadRequest), retries: record.Retries}}"
        >{{formatDate(requestTime)}}</router-link>
      </template>
      <template slot="form-id" slot-scope="form_id, record">
        <router-link
          :to="{path:`/view-country-error/${record.FormId}/${record.LeadGenId}`, query: {processor: determineProcessor(record.LeadRequest), retries: record.Retries}}"
        >{{form_id}}</router-link>
      </template>
      <template slot="mapping-status" slot-scope="status, record">
        <router-link
          :to="{path:`/view-country-error/${record.FormId}/${record.LeadGenId}`, query: {processor: determineProcessor(record.LeadRequest), retries: record.Retries}}"
          :class="{error: status.includes('Err') || status.includes('Test')}"
        >Error with value for country</router-link>
      </template>
      <template slot="num-of-attempts" slot-scope="retries, record">
        <router-link
          :to="{path:`/view-country-error/${record.FormId}/${record.LeadGenId}`, query: {processor: determineProcessor(record.LeadRequest), retries: record.Retries}}"
        >{{retries}}</router-link>
      </template>
    </a-table>
    <a-spin size="large" v-if="loading"></a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

const sortFields = (a, b) => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};

const columns = [
  {
    title: "Request Time",
    dataIndex: "CreatedAt",
    sorter: (a, b) => sortFields(a.CreatedAt, b.CreatedAt),
    scopedSlots: { customRender: "last-request" },
  },
  {
    title: "Form Id",
    dataIndex: "FormId",
    scopedSlots: { customRender: "form-id" },
  },
  {
    title: "Processing Status",
    dataIndex: "StatusDate",
    key: "Status", //needs a unique key because we also use StatusDate in Retry column
    scopedSlots: { customRender: "mapping-status" },
  },
  {
    title: "Num. of Attempts",
    dataIndex: "Retries",
    scopedSlots: { customRender: "num-of-attempts" },
  },
];
export default {
  computed: {
    ...mapState(["user", "apiUrl", "formName"]),
  },
  data() {
    return {
      columns,
      data: [],
      loading: true,
    };
  },
  methods: {
    formatDate(d) {
      const date = new Date(d);
      return date.toLocaleString();
    },
    loadLogs() {
      this.loading = true;
      setTimeout(() => {
        axios({
          url: `${this.apiUrl}/logs`,
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
          params: {
            action: 'COUNTRY_ERRORS',
          },
        })
          .then((rslt) => {
            this.data = rslt.data.sort((a, b) => {
              if (a.CreatedAt > b.CreatedAt) {
                return -1;
              }
              if (a.CreatedAt < b.CreatedAt) {
                return 1;
              }
              return 0;
            });
            this.loading = false;
          })
          .catch((err) => {
            alert("Unable to load logs");
            this.loading = false;
          });
      }, 500);
    },
    determineProcessor(leadRequest) {
      const r = JSON.parse(leadRequest)
      if ("google_key" in r) {
        return "google";
      }
      return "facebook";
    },
    goBack() {
      this.$router.back();
    },
  },
  mounted() {
    this.loadLogs();
  },
  props: [],
};
</script>

<style lang="scss" scoped>
#title-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
h1 {
  margin-right: 20px;
}
.error {
  //text-transform: capitalize;
  color: #f5222d;
}
.retrying {
  color: #777;
  cursor: default;
}
.select-log-type {
  width: 198px;
  margin-left: auto;
}
</style>
